import { render, staticRenderFns } from "./GroupFigure.vue?vue&type=template&id=4a34a83c&scoped=true"
import script from "./GroupFigure.vue?vue&type=script&lang=js"
export * from "./GroupFigure.vue?vue&type=script&lang=js"
import style0 from "./GroupFigure.vue?vue&type=style&index=0&id=4a34a83c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a34a83c",
  null
  
)

export default component.exports